<!--
================================================
Un composant affichant un bloc détaillant un plan
http://localhost:8080/fr/adobe/subscription
⚠️ Ce composant a été copié depuis le site nuxt et adapté pour la pwa

================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->
<template>
  <div class=" planBloc" v-bind:class="[{ 'darkMode':themeToDisplay=='dark' }, plan.name]">

    <h4 v-bind:style="{color:plan.color}">{{ plan.name }}</h4>

    <br>
    <span class="premiumMark" v-if="plan.isPremium" :title="$t('planPremium')">
      <font-awesome-icon :icon="['fas', 'medal']" class="iconM ml-3"/> </span>

    <div class="price">
      <span class="month" v-if="!billPerYear">
        {{ plan.priceMonth }} {{ currencyToSign(plan.currency) }}
        /<b>{{ $t('mois') }}</b>
      </span>

      <span class="year" v-else>  {{ plan.priceYear }} {{ currencyToSign(plan.currency) }}
        /<b>{{ $t('an') }}</b>
      </span>
      <div class="perUser"> {{ $t('parUtilisateur') }}
        <div class="bonus">
          <span class="txt" v-show="billPerYear && plan.priceYear != 0">{{ $t('xMoisGratuits', {count: 2}) }} !</span>
        </div>

      </div>

      <span class="baseline">{{ $t(plan.baseline) }}</span>

    </div>

    <ul class="feat">
      <li>
        <font-awesome-icon :icon="['fas', 'check']" class="icon check"/>
        {{ $t('suiviDeTemps') }}
      </li>
      <li :class="{'missFeat':!plan.features.projectDashboard}">
        <font-awesome-icon v-if="plan.features.projectDashboard" :icon="['fas', 'check']" class="icon check"/>
        <font-awesome-icon v-else :icon="['fas', 'times']" class="icon time"/>
        <span>{{ $t('tableauxDeBordProjets') }}</span>
      </li>


      <li v-if="plan.features.projectMax==9999">
        <font-awesome-icon :icon="['fas', 'check']" class="icon check"/>
        {{ $t('projetsIllimités') }}
      </li>
      <li v-else v-html="$t('xProjets',{count: plan.features.projectMax })"></li>

      <!--      <li v-if="plan.features.premiumOnboarding">-->
      <!--        <font-awesome-icon v-if="plan.features.projectDashboard" :icon="['fas', 'check']" class="icon check"/>-->
      <!--        <font-awesome-icon v-else :icon="['fas', 'times']" class="icon time"/>-->
      <!--        <span >{{$t('onboardingAssitéWip')}}</span>-->
      <!--      </li>-->
      <!--      <li v-else>-->
      <!--        <br>-->
      <!--        &lt;!&ndash; lign conservée pour que les plans aient la même taille &ndash;&gt;-->
      <!--      </li>-->

      <li v-html="$tc('xUtilisateurs', plan.features.userMax )"></li>

      <li v-if="plan.features.climate" class="climate">{{ $t('UnPourcentConsacréAuClimat') }}
        <font-awesome-icon :icon="['fas', 'heart']" class="icon heart"/>
      </li>
      <li v-else>
        <br>
        <!--        je garde cette ligne pour que ce plan ait la même hauteur que les autres-->
      </li>
    </ul>


    <!--    https://vuestripe.com/stripe-checkout/getting-started/-->
    <stripe-checkout
        ref="checkoutRef"
        :pk="publishableKey"
        :sessionId="stripeCheckoutSessionId"
        @loading="v => loading = v"
    />


    <div v-if="user.isVerified">
      <!-- Mention "Abo actuel" - Si le plan est l'abo actuel (et qu'une future date de fin de trial n'est pas définie)-->
<!--      && plan.features.isPremium != true @todo supr si pas de pb-->
      <button  v-if="activeStripePriceId==priceIdForCycle && !dateIsInFuture(workspaceTrialEnd) "   class="activePlan button is-fullwidth cas1" :style="{border:'dashed 1px '+plan.color,color:plan.color}" :class="plan.class" >
        {{ $t('abonnementActuel') }}
      </button>

      <!--  c2a "démarrer trial"
      ( - si aucun trial démarré - sauf plan gratuit - et qu'une future date de fin de trial n'est pas définie)--->
      <button v-else-if="workspaceTrialStarted !=true && plan.features.isPremium && !dateIsInFuture(workspaceTrialEnd)" class="button is-fullwidth cas2" :style="{'background-color':plan.color}" :class="plan.class" v-on:click="showModalConfirmTrialStart()" >
        {{ $t('ESSAYERGRATUITEMENT') }} <br>
        {{ $t('PendantXJours',{count:plan.trialPeriodDays}) }} 🎁
      </button>


      <!-- Sinon c2a "mettre à niveau"-->
      <button v-else  class="button is-fullwidth" v-on:click="getCheckoutSession(), checkoutGenerating=true" :style="{'background-color':plan.color}" :class="plan.class">

        <span v-if="activeStripePriceId==demoPlanPriceId"> <!-- si le plan actuel est le plan demo -->

          <span v-if="checkoutGenerating==false"> {{$t('MettreÀNiveau')}}</span>
          <span v-else>
            <span>{{$t('redirectionVersLePaiement')}}</span>
            <font-awesome-icon class="icon spinnerIcon " :icon="['fas', 'spinner']" spin />
          </span>

      </span>
        <span v-else>

          <!-- Si le plan est inférieur au plan actuel ("rétrograder") -->
        <span v-if="getPriceHierarchy(billPerYear,locale).planPosition <  getPriceHierarchy(billPerYear,locale).activePlanPosition ">

          <span v-if="checkoutGenerating==false">{{ $t('Rétrograder') }}</span>
          <span v-else>
            <span>{{ $t('redirectionVersLePaiement') }}</span>
            <font-awesome-icon class="icon spinnerIcon " :icon="['fas', 'spinner']" spin/>
          </span>

        </span>
        <span v-else>

          <span v-if="checkoutGenerating==false">{{ $t('MettreÀNiveau') }}</span>
          <span v-else>
            <span>{{ $t('redirectionVersLePaiement') }}</span>
            <font-awesome-icon class="icon spinnerIcon " :icon="['fas', 'spinner']" spin/>
          </span>
        </span>

      </span>
      </button>

      <!-- Si le plan est l'abo actuel mais que le trial est en cours-->
      <span class=" tag is-warning isThird has-text-weight-bold mt-3  is-absolute markerTrial" v-if="activeStripePriceId==priceIdForCycle && dateIsInFuture(workspaceTrialEnd)">🎁 {{$t('EssaiGratuitEncoursJusquAu',{date:$moment.unix(workspaceTrialEnd).format('l')})}} </span>
    </div>


  </div>
</template>

<!------------------------------------------------
+++++++++++++++++++++ SCRIPT ++++++++++++++++++++++
-------------------------------------------------->
<script>

// import foo from "../components/foo";
import {mapState} from 'vuex'
import { StripeCheckout } from '@vue-stripe/vue-stripe';
import InterceptorMixin from "@/mixins/InterceptorMixin";
import router from "@/router";
import i18n from "@/i18n";
import CurrencyMixin from "@/mixins/CurrencyMixin";

export default {
  name: "planBloc",

  props: {
    /** pour typage et validation voir :
     *  https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
     *  https://fr.vuejs.org/v2/guide/components-props.html#Validation-des-props
     **/
    //
    plan: {
      // Le plan à afficher
      type: Object, required: true,
    },

    activeStripePriceId:{ // le priceId de la subscription en cours
      type: String,
      required: true

    },

    billPerYear: { // Boolean si true le cycle de facturation est annuel sinon mensuel
      type: Boolean, required: true, default: false
    },
    stripeCustomerEmail: { // l'email du customer stripe //@todo inutile à supre ?
      type: String, required: true,
    },

    preparedPriceHierarchy: { // les plans pour la culture en cours (permet de définir la hiérarchie dans getPriceHierarchy()) @see PlansBlocSectionComp.preparePriceHierarchy()
      type: Object, required: true, default: false

    }


  },
  data: function () {
    return {
      locale : this.$route.params.locale,
      organization : this.$route.params.organization,
      userSlug: JSON.parse(this.$cookie.get('auth')).userSlug,
      workspaceSlug: this.$auth.getActiveWorkspace(),

      // clé publiable de stripe
      publishableKey : process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,

      //@todo est-ce la bonen valeur spour clientReferenceId (différent dans backend) @deprecated ?
      clientReferenceId: this.$auth.getActiveWorkspace(), // IMPORTANT : dans le formulaire on passe l'id du workspace via le paramètre clientReferenceId cela permettra dans le backend de capturer l'event checkout.session.completed afin de rattacher une subscription à un workspace.//  @link https://vuestripe.com/stripe-checkout/getting-started/


      checkoutGenerating: false, // Boolean indiquant si une requête de redirection vers stripe checkout est en cours

      customerEmail: null, // @todo inutile à supre ?
      stripeCheckoutSessionId: '', // String l'id de la session stripe checkout
      demoPlanPriceId: null // Le stripe priceId du plan démo (pour la culture de l'utilisateur)


    }
  },
  mixins: [InterceptorMixin, CurrencyMixin],
  components:{StripeCheckout},

  computed: {
    ...mapState({
      user: state => state.user,
      themeToDisplay: state => state.app.themeToDisplay,
      workspaceTrialStarted : state => state.SubscriptionView.workspace.trialStarted,
      workspaceTrialEnd : state => state.SubscriptionView.workspace.trialEnd,
    }),

    /**
     * Retourne l'identifiant du prix Stripe en fonction du cylce de facturation mensuel/annuel
     */
    priceIdForCycle: {
      get: function(){
        if (this.billPerYear) {
          return this.plan.stripeYearPriceId;
        }else {
          return this.plan.stripeMonthPriceId
        }
      }
    },

  },

  methods: {

    /*
    *
    */
    dateIsInFuture(date){

      // let testDate= this.$moment.unix(date).format("ll");

      if (this.$moment.unix(date).isAfter()){
        return true
      }

    },
    /**
     * Retourne la hierarchy du plan en cours dans les plans disponibles pour la culture.
     *
     * Exemple si on est sur le second plan et qu'il y a 3 plans au total la hierarchie est 2 sur 3 et retournera :
     {
        "planPosition": 2,
        "plansCount": 3,
        "activePlanPosition": 3
       }.
     * 🎁 Permet de dire que si l'on choisit ce plan cela représente une  "rétrogradation" par rapport à l'abonnement acutel.
     *
     * Cette méthode gère la localisation i10n @todo ajouter dans doc ajout de locale
     *
     * @param billPeryear boolean Si vaut true le cycle de facturation est annuel, sinon mensuel
     * @param locale String
     * @return Object {planPosition (position du plan), plansCount (nombre total du plan), activePlanPosition (position du plan de l'abonnement actif)}
     */
    getPriceHierarchy(billPeryear, locale){

      let hierarchy = this.preparedPriceHierarchy

      let billinCycle
        let planPrice4Cycle; // le prix du plan actuel compte tenu du cycle de facturation

        if(billPeryear){
          billinCycle = 'year'; planPrice4Cycle=this.plan.stripeYearPriceId;
        }
        else{
          billinCycle = 'month'; planPrice4Cycle=this.plan.stripeMonthPriceId;
        }

        // calcul du nombre total de plan pour la culture et le billingCycle
        let plansCount =hierarchy[locale][billinCycle].length

        let planPosition = 1 + hierarchy[locale][billinCycle].indexOf(planPrice4Cycle);

        let activePlanPosition = 1 + hierarchy[locale][billinCycle].indexOf(this.activeStripePriceId);
      return {planPosition:planPosition, plansCount : plansCount, activePlanPosition: activePlanPosition}
      },


    /*
      Effectue une requête pour récupérer la session stripe checkout
    */
    getCheckoutSession() {

        // définition des params d'url
        const params = {
          priceId: this.priceIdForCycle,
        }
        let self =this;
        return self.$http
            .get(`/s/organizations/${self.organization}/workspaces/${self.workspaceSlug}/users/${self.userSlug}/checkout/session`,
                {
                  params,
                  headers: {Authorization: self.$auth.header()}
                })
            .then(function (response) {
              self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

              self.stripeCheckoutSessionId=response.data.id
              self.submit()
              return {
              }
            })
            .catch(function (error) {
              let errorCode = '0058'
              let errorMsq = 'error fetching stripe session'
              self.showGlobalErrorNotif(self,errorCode)
              self.$gtag.exception({'description': 'error '+errorCode + ' | '+errorMsq, 'fatal': false})
              self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": errorMsq})
              self.$sentry.captureMessage(`Error ${errorCode} > ${errorMsq} : ${error}`, 'error')

          }).then(() => {
            // toujours exécuté
          })
    },

    /**
     * Soumet le formulaire checkout de vue-stripe
     */
    submit () {
      // You will be redirected to Stripe's secure checkout page
      this.$refs.checkoutRef.redirectToCheckout();
    },

    /*
    Déclenche l'affichage de modalPremiumLimitation en mode confirmTrialStart
    */
    showModalConfirmTrialStart(){

      this.$root.$emit(
          'show_modal_premium_limitation',
          'confirmTrialStart',
          this.$t('DémarrerLEssaiGratuit', {count: this.plan.trialPeriodDays}) + '...',
          this.$t('EssayezToutesLesFonctionsSansLimiteAucuneCarteBancaireRequise', {count: this.plan.trialPeriodDays, plan :this.plan.name}),
          null,
          this.priceIdForCycle
      );

    },

    /**
    Effectue une requête pour créer une Stripe subscription (pour démarrer un trial)
    @param string stripePriceId
  */
    postTrialSubscription(stripePriceId) {

      let self =this;

      return self.$http
          .post(`/s/organizations/${self.organization}/workspaces/${self.workspaceSlug}/subscriptions`,
              {
                priceId: self.priceIdForCycle,
                isTrial: true,
              },
              {headers: {Authorization: self.$auth.header()}}
          )
          .then(function (response) {
            self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
            self.$store.commit('UpdateSubscriptionViewWorkspaceTrialStarted', true)
            self.$store.commit('UpdateSubscriptionViewWorkspaceTrialEnd', response.data.stripeSubscription.trial_end)

            self.$router.replace({
              name: 'subscription-success',
              params: {locale: self.locale, organization: self.organization, workspace: self.workspaceSlug},
              query: {client_reference_id:response.data.subscription.clientReferenceId}
            })

            return {
            }
          })
          .catch(function (error) {
            // On catch ici sauf ce qui relève des intercepteurs Axios
            if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
              let errorCode = '0058b'
              let errorMsq = 'error starting trial subscription'
              self.showGlobalErrorNotif(self, errorCode)
              self.$gtag.exception({'description': 'error ' + errorCode + ' | ' + errorMsq, 'fatal': false})
              self.$mixpanel.track('global error displayed', {"id": errorCode, "detail": errorMsq})
              self.$sentry.captureMessage(`Error ${errorCode} > ${errorMsq} : ${error}`, 'error')
            }

          }).then(() => {
            // toujours exécuté
          })
    },

  },

  mounted: function () {

    this.demoPlanPriceId = this.preparedPriceHierarchy[this.locale].month[0]

    this.getPriceHierarchy(this.billPerYear,this.locale)


    /*
     * Event trial_start_confirmed, déclenche la création de la subscription de trial
     * @param priceIdSource | Un stripe PriceId pour identifier le planBLoc à notifier
     */
    this.$root.$on('trial_start_confirmed', (priceIdSource) => {

      if(this.plan.stripeMonthPriceId == priceIdSource || this.plan.stripeYearPriceId == priceIdSource){
        this.postTrialSubscription()
      }

    })
  }

}
</script>

<!------------------------------------------------
+++++++++++++++++++++ CSS ++++++++++++++++++++++++
-------------------------------------------------->
<style scoped lang="scss">
@import "../../assets/css/globalVar";
@import "../../assets/css/bulmaResponsiveDep";



  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////
.planBloc {
  background: #fff;
  padding: 1.5rem ;
  border-radius: .3rem;
  box-shadow: 0 0 4px #ccc;
  border: dashed 1px $brandFourth;
  position: relative;

  transition: box-shadow .35s;

  .markerTrial{
    margin: auto;
  }
  @include touch {
    margin-bottom: 3rem;
  }

  &:hover {
    box-shadow: 0 .2rem 1rem darken(#ccc, 10%);
  }

  h4 {
    font-size: 3rem;
    font-family: $mainFont2;
    font-weight: $mainFont2WeightBold;
    text-align: center;
  }

  .premiumMark {
    color: $brandPremium;
    $s: 2rem;
    height: $s;
    width: $s;
    font-size: $s;
    position: absolute;
    right: 3rem;
    top: 2.5rem;
    @include touch {
      $s: 1.6rem;
      font-size: $s;
      height: $s;
      width: $s;


    }
  }

  .price {
    position: relative;
    text-align: center;
    font-size: 1.9rem;
    color: $brandThird;
    line-height: 1.6rem;
    margin-top: 1.5rem;

    .perUser {
      font-size: 1.1rem;
      color: $brandFourth;
      margin-bottom: .4rem;
    }

    .baseline {
      background: #faf6d1;
      font-size: .9rem;
      padding: .2rem .65rem .2rem .4rem;
    }

    .bonus {
      min-height: 1.8rem;
      padding: 0;
      font-size: .8rem;
      font-weight: bold;
      margin: 0 0 0 .3rem;
      color: $brandPremium;


      .txt {
        &:before {
          content: '🎁'; margin-right: .2rem;
          animation: glow .9s infinite alternate;
        }

        @keyframes glow {
          from {
            opacity: 1;
          }

          to {
            opacity: 0;
          }
        }
      }

    }
  }

  ul.feat {
    margin: 2rem 1rem;
    text-align: left;

    li {
      margin-bottom: .5rem;

      .icon {
        vertical-align: middle;
        margin-right: .2rem;
      }

      .icon.check {
        color: $brandPrimary;
      }

      .icon.times {
        color: $brandFourth;
      }

      &.missFeat {
        color: $brandFourth !important;
      }

      &.climate {
        font-size: .9rem;
        color: #999;
        .icon {
          color: $brandPrimary;
        }
      }
    }
  }

  .button {
    padding: 2rem 1rem;
    text-align: center;
    margin: auto;
    border: none;
    font-weight: bold;
    color: white;
    border:solid 1px transparent;
    //text-transform: capitalize;
    .spinnerIcon{margin: 0 0 0 .5rem ; vertical-align: middle}

    // pour le bouton du plan actif on désactive les styles :hover & :active
    &.activePlan{
      cursor: default;
      background-color: transparent;
      &.plus, &.max, &.lite{
        &:hover,&:active{background-color: transparent !important;}
      }

    }
    &:hover{
      transition: background-color .2s ;
    }
    &.lite{
      &:hover{background-color: lighten($brandFourth,5%)!important;}
      &:active{background-color: darken($brandFourth,5%)!important;}
    }
    &.plus{
      &:hover{background-color: lighten($brandBlue,5%)!important;}
      &:active{background-color: darken($brandBlue,5%)!important;}}
    &.max{
      &:hover{background-color: lighten($brandPrimary,5%)!important;}
      &:active{background-color: darken($brandPrimary,5%)!important;}
    }

  }
  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {
    background-color: $darkBg2;
    box-shadow: none;

    .markerTrial{
      background-color: $yellow;
      color:$darkBg2 !important;
    }

    .price {
      color: $darkContrastTxt;
      .perUser{
        color: #626565 !important;
      }
      .baseline{
        background-color: $darkBg; color: $brandYellow;
      }
    }
    ul.feat{
      li{
        color: $darkContrastTxt;
      }
    }
  }

}

</style>
